export default __webpack_public_path__ + "static/media/about-us.2e2fc0eb.png";